import InputPublisher from './InputPublisher.vue'

export { InputPublisher }
